// styles/shadows.ts
export const elevation = {
  0: "none",
  1: "0 1px 3px rgba(0,0,0,0.1)",
  2: "0 2px 6px rgba(0,0,0,0.12)",
  3: "0 4px 12px rgba(0,0,0,0.12)",
  4: "0 6px 20px rgba(0,0,0,0.14)",
  5: "0 10px 30px rgba(0,0,0,0.16)",
};
